import { fetchChannelEnrichments } from 'mrt-apis';

export async function fetchChannelEnrichmentsQuery(channelUrls: string[]) {
  if (!channelUrls.length) return [];
  const response = await fetchChannelEnrichments(channelUrls);
  return response?.data?.data ?? [];
}
